module.exports = __webpack_public_path__ + "static/media/toba-doc.1a7fbfd0.pdf";